export class Gender {
  public id?: string;
  public name: string;
}
